import {Component, EventEmitter, Input, Output, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Observable} from 'rxjs';
import {Absence} from '../models/absence.model';
import {SickLeaveService} from '../services/sick-leave.service';
import {DatevAuthStatusService} from '../services/datev-auth-status.service';
import {getAbsenceStatusText, getAbsenceStatusClass, getAbsenceErrorDetail} from './absence-status.util';

// Bündelt Status-Badge, Fehlergrund und die manuellen EAU-Aktionen (Jobergebnis abholen/eAU
// anlegen/einreichen/Rückmeldung abholen/stornieren) einer einzelnen Krankmeldungs-Zeile. Wird
// per [leave] sowohl in der Übersichtstabelle als auch im Mitarbeiter-Detail-Modal eingebunden -
// vorher war diese gesamte Logik samt Markup in beiden Komponenten dupliziert.
@Component({
    selector: 'app-eau-row-actions',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './eau-row-actions.component.html',
    styleUrls: ['./eau-row-actions.css'],
    // display: contents, damit die hier gerenderten <td>s direkt Zellen der umgebenden <tr> des
    // Hosts werden, statt vom <app-eau-row-actions>-Element selbst ins Tabellenlayout eingefügt
    // zu werden (das würde die Spaltenstruktur brechen).
    host: {style: 'display: contents'},
})
export class EauRowActionsComponent {
    @Input({required: true}) leave!: Absence;
    // Erfolgreiche Aktion ändert den Status der Krankmeldung serverseitig - der Host (Übersicht
    // bzw. Mitarbeiter-Modal) lädt daraufhin seine eigene, je nach Ansicht unterschiedlich
    // gefilterte Liste still neu, statt dass diese Komponente selbst wissen muss, wie das geht.
    @Output() actionCompleted = new EventEmitter<void>();

    getStatusText = getAbsenceStatusText;
    getStatusClass = getAbsenceStatusClass;
    getErrorDetail = getAbsenceErrorDetail;

    actionLoading = signal(false);
    actionError = signal<string | null>(null);

    constructor(
        private sickLeaveService: SickLeaveService,
        public datevAuthService: DatevAuthStatusService,
    ) {
    }

    retrieveJobResult() {
        this.runAction(() => this.sickLeaveService.retrieveJobResult(this.leave.id));
    }

    createEau() {
        this.runAction(() => this.sickLeaveService.createEau(this.leave.id));
    }

    submitEau() {
        this.runAction(() => this.sickLeaveService.submitEau(this.leave.id));
    }

    retrieveFeedback() {
        this.runAction(() => this.sickLeaveService.retrieveFeedback(this.leave.id));
    }

    cancelFeedback() {
        this.runAction(() => this.sickLeaveService.cancelFeedback(this.leave.id));
    }

    // requestFactory statt eines bereits erzeugten Observable: so ist sichergestellt, dass
    // actionLoading gesetzt ist, BEVOR der Service-Aufruf (und damit ein evtl. synchron
    // ausgeführter HTTP-Mock/Spy) ausgeführt wird.
    private runAction(requestFactory: () => Observable<any>) {
        this.actionLoading.set(true);
        this.actionError.set(null);

        requestFactory().subscribe({
            next: () => {
                this.actionLoading.set(false);
                this.actionCompleted.emit();
            },
            error: (error: string) => {
                this.actionLoading.set(false);
                this.actionError.set(error);
            }
        });
    }
}
